<template>
  <div id="fullpage">
    <div class="preloader">
      <div class="spinner">拿度</div>
    </div>
    
    <!-- Map Area Starts -->
    <section class="map-area section-padding lianxi_section1 section" style="background-size:auto 100% !important;">
      <div class="banner-sun">
        <p class="p1 animate fadeInDown animated jjfangan_zt1"
          style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">联系我们</p>
        <p class="p2 animate zoomIn animated jjfangan_zt2"
          style="animation-duration: 1s; animation-delay: 1s; visibility: visible; color: #E91E63;">CONTACT US</p>
        <!-- <P class="p3 animate fadeInUp animated jjfangan_zt3"
          style="animation-duration: 1s; animation-delay: 0.3s; visibility: visible;">烟台拿度智能科技有限公司</P> -->
      </div>
      <div class="animate bounce animated"
        style="width: 100%; height: 100px; line-height: 100px; text-align: center;animation-duration: 1s; animation-delay: 1s; visibility: visible;">
        <img src="/static/assets/images/shubiao.png" />
      </div>
    </section>
    <!-- Map Area End -->


    <!-- Contact Form Starts -->
    <section class="contact-form lianxi_section2 section">
      <div class="lianxibiao">

        <div class="lianxibiao1">
          <div class="d-flex donghuaDown" style="animation-duration:1s; animation-delay: 0.2s; visibility: visible;">
            <div class="info-text">
              <span class="llx1" style="border-bottom:0px;color: #e40230;">联系方式 </span>
              <!-- <span class="llx2" style="color: #505050;"> CONTACT US</span> -->
            </div>
          </div>

          <div class="d-flex top-30  donghuasun"
            style="animation-duration: 0.5s; animation-delay: 0.3s; visibility: visible;color: white;">
            <div class="info-text">
              <p class="shoujino" v-html="lianxiwomen.content"></p>
              <div class="shoujiok">
                <p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem;">
                  公司地址：
                <div class="zzz123">山东省烟台经济技术开发区珠江路32号3号楼</div>
                </p>
                <p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem;">
                  业务电话：
                <div class="zzz123">18562255186<br>18596163696<br>18562255176</div>
                </p>
                <p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem;">
                  公司传真：
                <div class="zzz123">0535-6936196</div>
                </p>
                <p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem;">
                  企业邮箱：
                <div class="zzz123">ytndkj@163.com   2141299192@qq.com</div>
                </p>
                <p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem;">
                  QQ &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：2141299192
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="d-flex  donghuasun"  style="animation-duration: 0.5s; animation-delay: 0.4s; visibility: visible;">
              <div class="info-text">
                <p>联系电话：18562255186 / 18596163696 / 18562255176</p>
              </div>
            </div>
            <div class="d-flex  donghuasun"  style="animation-duration: 0.5s; animation-delay: 0.5s; visibility: visible;">
              <div class="info-text">
                <p>公司传真：0535-6939276</p>
              </div>
            </div>
			<div class="d-flex  donghuasun"  style="animation-duration: 0.5s; animation-delay: 0.6s; visibility: visible;">
			  <div class="info-text">
			    <p>企业邮箱：ytndkj@163.com / 2141299192@qq.com</p>
			  </div>
			</div>
			<div class="d-flex  donghuasun"  style="animation-duration: 0.5s; animation-delay: 0.7s; visibility: visible;">
			  <div class="info-text">
			    <p>QQ：2141299192</p>
			  </div>
			</div> -->
          <div class="d-flex  donghuasun lianxibuxians"
            style="animation-duration: 0.5s; animation-delay: 0.8s; visibility: visible;">
            <div class="info-text">
              <p class="zxdh" style="font-weight: 600;">咨询电话</p>
              <p class="zxdh1" style="color: #ffffff;">{{ qiyeinfo.phone }}</p>
            </div>
          </div>
          <div class="d-flex  donghuasun lianxibuxians"
            style="animation-duration: 0.5s; animation-delay: 0.9s; visibility: visible;">
            <div class="info-text">
              <div class="image-containerc-lx"></div>
              <div class="image-containera-lx"></div>
              <div class="image-containerb-lx"></div>
            </div>
          </div>
        </div>
        <div class="biaodan1 donghuaRight" style="animation-duration: 1s; animation-delay: 1s; visibility: visible;">
          <div class="biaodan2">
            联系我们
          </div>

          <div class="biaodan3">
            <div class="left" style="width: 80%;margin-left: 10%;">
              <p>
                <label>姓名：</label>
                <input type="messname" v-model="messname" style="width: 100%;border: 0px; padding: 10px;"
                  placeholder="请输入您的称呼" onfocus="this.placeholder = ''" onblur="this.placeholder = '请输入您的称呼'" required>

              </p>

              <p>
                <label>电话：</label>
                <input type="messtel" v-model="messtel" style="width: 100%;border: 0px; padding: 10px;"
                  placeholder="请输入您的联系电话" onfocus="this.placeholder = ''" onblur="this.placeholder = '请输入您的联系电话'"
                  required>
              </p>
              <label>内容：</label>
              <textarea type="messtitle" v-model="messtitle"
                style="width: 100%;border: 1px solid #eee;padding: 10px;height: 100px; margin-bottom: 20px;"
                name="message" cols="20" rows="7" placeholder="请输入您的留言内容" onfocus="this.placeholder = ''"
                onblur="this.placeholder = '请输入您的留言内容'" required></textarea>
              <button @click="buttonmess" type="submit" class="template-btnb"
                style="margin-bottom: 30px;background: #e40230; color: #ffffff;">提交</button>
            </div>
          </div>

        </div>

      </div>
    </section>
    <!-- Contact Form End -->
    <!-- Contact Form Starts -->
    <section class="contact-form section-padding3 lianxi_section3 section">
      <div class="lianxi_sun1">
        <div class="lianxi_sun2">
          <img src="/static/assets/images/lianxibn3.png" class="donghuaLeft"
            style="height: 100%; animation-duration: 1s; animation-delay: 0.5s; visibility: visible;" />
          <img src="/static/assets/images/lianxibn3z.png" class="donghuaLeft"
            style="height: 100%; margin-left: 30%; animation-duration: 1s; animation-delay: 0.1s; visibility: visible;" />
        </div>
        <div class="lianxi_sun3 donghuaRight"
          style="animation-duration: 1s; animation-delay: 0.8s; visibility: visible;z-index: 0;">
          <p class="rencai" v-html="linian1.content"></p>
        </div>
        <div class="lianxi_sun4 donghuaRight" style="animation-duration: 1s; animation-delay: 1.3s; visibility: visible;">
          <p class="rencai" v-html="linian2.content"></p>
        </div>
      </div>
    </section>
    <!-- Contact Form End -->


    <!-- Contact Form Starts -->
    <section class="contact-form section-padding3 lianxi_section4 section">
      <div class="zyfz001">
        <div class="zyfz002" style="animation-duration: 1s; animation-delay: 1s; visibility: visible;">
          <img src="/static/assets/images/zhiyefazhan.png" class="zhiyefazhan" />
        </div>
        <div class="zyfz003">
          <div class="zyfz3-1 donghuaLeft" style="animation-duration: 0.5s; animation-delay: 0.2s; visibility: visible;">
            <p style="font-size: 20px;color: #cccccc6b;" class="zhiyefazhan_01">REVIEW SYSTEM</p>
            <p style="font-size: 16px;font-weight: bold;" class="zhiyefazhan_02">01 科学的任职资格评审制度</p>
            <p class="zhiyefazhan_03">针对每位员工能力素质差异，制定个人职业发展计划 通过知识技能培训，提升工作能力，经过科学评审，获得轮岗/晋升机会</p>
            <br>
          </div>

          <div class="zyfz3-2 donghuaLeft" style="animation-duration: 0.5s; animation-delay: 0.5s; visibility: visible;">
            <p style="font-size: 20px;color: #cccccc6b;" class="zhiyefazhan_01">ENTERPRISE UNIVERSITY</p>
            <p style="font-size: 16px;font-weight: bold;" class="zhiyefazhan_02">02 拿度企业大学</p>
            <p class="zhiyefazhan_03">与知名院校合作，为员工提供高起专/专升本/工程硕士/MBA学历教育 完善的培训体系，为不同层级员工提供全方位技能/专业/管理的内外部培训课程</p>
            <br>
          </div>

          <div class="zyfz3-3">
            <!-- <div class="donghuaLeft tongdaoys"
              style="float: left;padding-top: 3%;animation-duration: 0.5s; animation-delay: 0.8s; visibility: visible;">
              <p v-html="fazhan.content"></p>
            </div> -->
            <p class="donghuaRight zhiyefazhan_01"
              style="font-size: 20px;color: #cccccc6b;animation-duration: 0.5s; animation-delay: 0.8s; visibility: visible;">
              PROMOTION</p>
            <p class="donghuaRight zhiyefazhan_02"
              style="font-size: 16px;font-weight: bold;animation-duration: 0.5s; animation-delay: 0.8s; visibility: visible;">
              03 多样的员工晋升通道</p>
            <p class="zhiyefazhan_03">提供多元化晋升路径、制定明确的晋升规划、提供培训和发展机会、建立良好的激励机制。</p>
          </div>


        </div>
      </div>
    </section>
    <!-- Contact Form End -->


    <!-- Contact Form Starts -->
    <section class="contact-form section-padding3 lianxi_section5 section">
      <div class="zpgw01">

        <div class="zpgw01-1">
          <div class="zpgw01-1-1 donghuasun"
            style="animation-duration: 0.6s; animation-delay: 0.2s; visibility: visible;">
            <p style="color: #E91E63;" class="zhiyefazhan_02">RECRUITING POSITIONS</p>
            <p style="color: #ffffff;" class="rencai1">招聘岗位</p>
          </div>

          <div v-for="(item, index) in zhaopin" :key="index" @click="openPopup(item.content)"
            class="zpgw01-1-2 donghuasunfadeIn"
            style="cursor: pointer; animation-duration: 1s; animation-delay: 0.8s; visibility: visible;">
            <p style="margin-top: 40px;">
              <img src="/static/assets/images/lxwmzpgw.png" />
            </p>
            <p style="font-size: 16px;" class="zhiyefazhan_02">{{ item.title }}</p>
            <p>招聘人数 : {{ item.ext_zhaopinrenshu }}人</p>
            <p>
            <div class="zp0112-1"></div>
            </p>
            <p style="margin-top: 100px;" class="chchaziti_s">
              <span>{{ item.ext_gongzuodidian }}</span>
            </p>



          </div>

          <div v-if="showPopup" class="popup-container" @click="guanbitc">

            <div style="width: 50%; text-align:left; background: #fff; padding: 20px; border-radius: 10px;"
              class="zuixintc_S">
              <p v-html="zhaopininfo"></p>
            </div>
            <div
              style="background: #E91E63; cursor: pointer;  padding: 10px 5px;  border-radius: 0px 5px 5px 0px;  color: #fff;"
              @click="guanbitc">关闭</div>

          </div>





          <!-- <div class="zpgw01-1-2 donghuasunfadeIn" style="animation-duration: 1s; animation-delay: 0.8s; visibility: visible;">
			  				  <p style="margin-top: 40px;">
			  					  <img src="/static/assets/images/lxwmzpgw.png"/>
			  				  </p>
			  				  <p style="font-size: 24px;">销售内勤</p>
			  				  <p>招聘人数 : 3人</p>
			  				  <p><div class="zp0112-1" ></div></p>
			  				  <p style="margin-top: 100px;">
			  					  <span>工作地点</span>
			  				  </p>
			  				  
			  </div>
			  <div class="zpgw01-1-2 donghuasunfadeIn" style="animation-duration: 1s; animation-delay: 0.8s; visibility: visible;">
			  				  <p style="margin-top: 40px;">
			  					  <img src="/static/assets/images/lxwmzpgw.png"/>
			  				  </p>
			  				  <p style="font-size: 24px;">销售内勤</p>
			  				  <p>招聘人数 : 3人</p>
			  				  <p><div class="zp0112-1" ></div></p>
			  				  <p style="margin-top: 100px;">
			  					  <span>工作地点</span>
			  				  </p>
			  				  
			  </div>
			  <div class="zpgw01-1-3 donghuasunfadeIn" style="animation-duration: 1s; animation-delay: 0.8s; visibility: visible;">
			  				  <p style="margin-top: 40px;">
			  					  <img src="/static/assets/images/lxwmzpgw.png"/>
			  				  </p>
			  				  <p style="font-size: 24px;">销售内勤</p>
			  				  <p>招聘人数 : 3人</p>
			  				  <p><div class="zp0112-1" ></div></p>
			  				  <p style="margin-top: 100px;">
			  					  <span>工作地点</span>
			  				  </p>
			  				  
			  </div> -->
        </div>
      </div>
    </section>
    <!-- Contact Form End -->

    <!-- Footer Area Starts -->
    <section class="footer-area section-padding9 section">
      <div class="footer-widget">
        <div class="container">
          <div class="row">

            <div class="col-xl-5 offset-xl-1 col-lg-6">
              <div class="single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd"
                style="animation-duration: 0.5s; animation-delay: 0.3s;">
                <h3 class="mb-4 phone_weibu_zt1" style="font-weight: 500;font-size: 20px;">专业技术团队 提供全方位系统解决方案</h3>
                <p class="mb-4" style="color: #7a7a7a;line-height: 60px;">如有任何疑问 请随时与我们联系</p>
                <form>

                  <input type="messname" v-model="messname" placeholder="您的姓名" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '您的姓名'" required>
                  <input type="messtel" v-model="messtel" placeholder="您的电话" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '您的电话'" required>
                  <input type="messtitle" v-model="messtitle" placeholder="您的留言" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '您的留言'" required>
                  <button type="submit" class="template-btnb" @click="buttonmess"
                    style="background: rgb(0 100 207);">立即提交</button>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="footer-copyright weibu_sun">
        <div class="container weibu912" style="padding-top: 50px;">
          <div class="weibu_a donghuasun" style="animation-duration: 0.6s; animation-delay: 0.3s;">
            <img src="/static/assets/images/logob.png" />
            <div class="image-counter">
              <div class="image-containerc"></div>
              <div class="image-containera"></div>
              <div class="image-containerb"></div>
              <!-- <img src="/static/assets/images/weixin.png" style="width: 35px;height: 35px;">
					<img src="/static/assets/images/douyin.png" style="width: 35px;height: 35px;">
					<img src="/static/assets/images/weibo.png" style="width: 35px;height: 35px;"> -->
            </div>
          </div>
          <div class="weibu_b donghuasun" style="animation-duration: 0.6s; animation-delay: 0.4s;">
            <p>工业物联网整体解决方案服务商</p>
            <p>智能传感解决方案专家</p>
          </div>
          <div class="weibu_c donghuasun" style="animation-duration: 0.6s; animation-delay: 0.5s;">
            <p>{{ zhandianinfo.copyright }}</p>
            <p>总部公司 : {{ qiyeinfo.address }}</p>
            <p>服务热线 : {{ qiyeinfo.mobile }}</p>
            <p>主营产品 : {{ qiyeinfo.other }}</p>
            <p>{{ zhandianinfo.icp }} <i><img src="/static/assets/images/gongan.png"
                  style="width:16px; height:16px;margin-bottom: 5px;"></i></p>
          </div>
        </div>
      </div>
    </section>
    <!-- Footer Area End -->


  </div>
</template>
<script>
import axios from 'axios';



export default {
  data() {
    return {
      qiyeinfo: [],
      zhandianinfo: [],
      daohanglist: [],
      lianxiwomen: [],
      showPopup: false,
      componentReady: false,
      linian1: [],
      linian2: [],
      fazhan: [],
      zhaopin: [],
      messtel: '',
      messname: '',
      messtitle: '',
      zhaopininfo: '',
    }
  },

  mounted() {
    this.componentReady = true;
    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.qiyeinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //站点信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.zhandianinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //导航数据
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.daohanglist = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
    //联系我们
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/19', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        console.log(response.data.data);
        this.lianxiwomen = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //人才理念1
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/48', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        console.log(response.data.data);
        this.linian1 = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //人才理念2
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/49', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        console.log(response.data.data);
        this.linian2 = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
    //职业发展
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/46', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        console.log(response.data.data);
        this.fazhan = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //招聘岗位
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/47', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        console.log(response.data.data);
        this.zhaopin = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });





  },
  methods: {
    //招聘弹窗
    openPopup(e) {
      this.showPopup = true;
      this.zhaopininfo = e;
    },
    //关闭弹窗
    guanbitc() {
      this.showPopup = false;
    },
    //提交留言
    buttonmess() {
      // Message.success(`输入的内容是: ${this.messtitle}`);
      if (this.messname != '' && this.messtel != '' && this.messtitle) {
        // console.log('可以继续进行');
        // console.log('输入的内容是:', this.messname);
        // console.log('输入的内容是:', this.messtel);
        // console.log('输入的内容是:', this.messtitle);
        axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/addmsg', {
          name: this.messname,
          tel: this.messtel,
          content: this.messtitle,
          appid: 'jurenkeji2024',
          timestamp: '1722845854',
          signature: '0eb76b812e96966c380b90c6e7416a26'
        })
          .then(response => {
            // console.log(response.data.data);
            // that.bannerlist = response.data.data;
            alert('留言提交成功!');
            this.messname = '';
            this.messtel = '';
            this.messtitle = '';
          })
          .catch(error => {
            console.error('当前网络环境异常!', error);
          });

      } else {
        alert('内容不能为空');
        return;
        // console.log('不能为空');
      }

    }

  }
}
</script>
<style scoped>
.popup-container {
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>




// WEBPACK FOOTER //
// ContactUs.vue?297b5a40